"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC721Holder__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "erdstall",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "erdstall",
        outputs: [
            {
                internalType: "contract Erdstall",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "value",
                type: "bytes",
            },
        ],
        name: "transfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class ERC721Holder__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(erdstall, overrides) {
        return super.deploy(erdstall, overrides || {});
    }
    getDeployTransaction(erdstall, overrides) {
        return super.getDeployTransaction(erdstall, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ERC721Holder__factory = ERC721Holder__factory;
ERC721Holder__factory.bytecode = _bytecode;
ERC721Holder__factory.abi = _abi;
//# sourceMappingURL=ERC721Holder__factory.js.map